import moment from 'moment'

export const transformDate = (date?: string | null, format = 'DD/MM/YYYY') => {
  if (!date) return ''

  return moment(date).format(format)
}
